const state = {
  mapeamento: null,
  mapeamentoComissao: null,
  mapeamentos: [],
  mapeamentosComissao: [],
  usuarioMapeamento: null,
  usuariosMapeamentos: [],
};

const actions = {
  setMapeamento({ commit }, payload) {
    return new Promise((resolve) => {
      switch (payload.tipo) {
        case 'COMISSAO':
          commit('SET_MAPEAMENTO_COMISSAO', payload.mapeamento);
          break;
        default:
          commit('SET_MAPEAMENTO', payload.mapeamento);
      }
      resolve();
    });
  },
  setMapeamentos({ commit }, payload) {
    return new Promise((resolve) => {
      switch (payload.tipo) {
        case 'COMISSAO':
          commit('SET_MAPEAMENTOS_COMISSAO', payload.mapeamentos);
          break;
        default:
          commit('SET_MAPEAMENTOS', payload.mapeamentos);
      }
      resolve();
    });
  },
};

const getters = {
  getMapeamento: (st) => (tipo) => {
    switch (tipo) {
      case 'COMISSAO':
        return st.mapeamentoComissao;
      default:
        return st.mapeamento;
    }
  },
  getMapeamentos: (st) => (tipo) => {
    switch (tipo) {
      case 'COMISSAO':
        return st.mapeamentosComissao;
      default:
        return st.mapeamentos;
    }
  },
};

const mutations = {
  SET_USUARIOS_MAPEAMENTOS(st, usuariosMapeamentos) {
    st.usuariosMapeamentos = usuariosMapeamentos;
  },
  SET_MAPEAMENTO(st, mapeamento) {
    st.usuarioMapeamento = st.usuariosMapeamentos.find((um) => um.mapeamento.id === mapeamento.id);
    st.mapeamento = mapeamento;
  },
  SET_MAPEAMENTO_BY_ID(st, mapeamentoId) {
    st.mapeamento = st.mapeamentos.find((m) => m.id === mapeamentoId);
    st.usuarioMapeamento = st.usuariosMapeamentos.find((um) => um.mapeamento.id === mapeamentoId);
  },
  SET_MAPEAMENTO_COMISSAO(st, mapeamento) {
    st.mapeamentoComissao = mapeamento;
  },
  SET_MAPEAMENTOS(st, mapeamentos) {
    st.mapeamentos = mapeamentos;
  },
  SET_MAPEAMENTOS_COMISSAO(st, mapeamentos) {
    st.mapeamentosComissao = mapeamentos;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
